export default ('lowercase', toConvert => toConvert.toLowerCase());
